const TOC_KEYS = [
  'ed-toc-1',
  'ed-toc-2',
  'ed-toc-3',
  'ed-toc-4',
  'ed-toc-5',
  'ed-toc-6',
  'ed-toc-7',
  'ed-toc-8',
];

const PROSE_KEYS = [
  'ed-prose-1',
  'ed-prose-2',
  'ed-prose-3',
  'ed-prose-4',
  'ed-prose-5',
];

interface SkeletonProps {
  classNameFlag?: boolean;
}

/**
 * Layout-accurate Editorial page skeleton — matches loaded V3 shell
 * (`.v3-report-content-card` with TOC column + prose body).
 */
export const Skeleton = ({ classNameFlag = true }: SkeletonProps) => {
  return (
    <div className={classNameFlag ? 'container-fluid' : undefined}>
      <div className={classNameFlag ? 'ao_mainContainer' : undefined}>
        <div className="row my-3">
          <div className="col order-sm-2 order-md-2">
            <div
              className="v3-report-content-card placeholder-glow"
              aria-hidden="true"
            >
              <div className="row">
                <div className="col-md-3 d-none d-md-block order-md-1">
                  {TOC_KEYS.map((key) => (
                    <span
                      key={key}
                      className="placeholder rounded col-10 d-block mb-2"
                      style={{ height: '0.85rem' }}
                    />
                  ))}
                </div>
                <div className="col order-sm-2 order-md-2">
                  <span
                    className="placeholder rounded col-6 d-block mb-2"
                    style={{ height: '1.35rem' }}
                  />
                  <hr className="my-2" />
                  {PROSE_KEYS.map((key) => (
                    <div className="mb-3" key={key}>
                      <span className="placeholder rounded col-11 d-block mb-2" />
                      <span className="placeholder rounded col-9 d-block mb-2" />
                      <span className="placeholder rounded col-10 d-block mb-2" />
                      <span
                        className="placeholder rounded col-7 d-block"
                        style={{ height: '0.75rem' }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
